import { HTTP_METHODS, URLS } from '../helpers/constants';
import axiosWithPayloadInterceptor from '../interceptor/axiosWithPayloadInterceptor';

class SearchDataProxy {
  static async fetchItemSearchData(data) {
    const { supc, vendors } = data;
    const url = `${URLS.ITEM_GROUP_BASE_URL}/search`;
    const config = {
      url,
      method: HTTP_METHODS.GET,
      params: {
        supc,
        vendors: vendors.join(',')
      }
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }
}

export default SearchDataProxy;
